import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
    page: { 
        padding: 40, 
        paddingBottom: 60,
        fontSize: 9, 
        fontFamily: 'Helvetica', 
        color: '#1f2937',
        backgroundColor: '#ffffff'
    },
    
    // Header & Meta
    header: { 
        marginBottom: 20,
        borderBottomWidth: 1,
        borderBottomColor: '#f3f4f6',
        paddingBottom: 10
    },
    title: { 
        fontSize: 20, 
        fontFamily: 'Helvetica',
        fontWeight: 'bold', 
        color: '#111827',
        letterSpacing: -0.5
    },
    subtitle: { 
        fontSize: 10, 
        color: '#6b7280', 
        marginTop: 4 
    },
    meta: { 
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        marginTop: 12, 
        padding: 12, 
        backgroundColor: '#f9fafb', 
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#f1f5f9'
    },
    metaItem: { 
        flexDirection: 'column',
        gap: 2
    },
    metaLabel: { 
        fontSize: 7,
        fontFamily: 'Helvetica',
        fontWeight: 'bold', 
        color: '#9ca3af',
        textTransform: 'uppercase'
    },
    metaValue: { 
        fontSize: 9,
        color: '#374151',
        fontFamily: 'Helvetica',
        fontWeight: 'bold'
    },

    // Sections
    sectionTitle: { 
        fontSize: 11, 
        fontFamily: 'Helvetica',
        fontWeight: 'bold', 
        color: '#111827', 
        marginTop: 24, 
        marginBottom: 10, 
        paddingLeft: 4,
        borderLeftWidth: 3,
        borderLeftColor: '#2563eb'
    },

    // Table styles
    table: { 
        marginBottom: 16,
        borderRadius: 8,
        overflow: 'hidden',
        borderWidth: 1,
        borderColor: '#f1f5f9'
    },
    tableHeader: { 
        flexDirection: 'row', 
        backgroundColor: '#f8fafc', 
        paddingVertical: 8, 
        paddingHorizontal: 10, 
        borderBottomWidth: 1, 
        borderBottomColor: '#f1f5f9' 
    },
    tableHeaderCell: { 
        fontSize: 7, 
        fontFamily: 'Helvetica',
        fontWeight: 'bold', 
        color: '#64748b', 
        textTransform: 'uppercase' 
    },
    tableRow: { 
        flexDirection: 'row', 
        paddingVertical: 7, 
        paddingHorizontal: 10, 
        borderBottomWidth: 1, 
        borderBottomColor: '#f8fafc' 
    },
    tableCell: { 
        fontSize: 8, 
        color: '#334155' 
    },

    // Resource Overview (Hierarchisch)
    resourceGroup: {
        marginBottom: 10,
        padding: 8,
        backgroundColor: '#f8fafc',
        borderRadius: 6
    },
    resourceGroupTitle: {
        fontSize: 9,
        fontFamily: 'Helvetica',
        fontWeight: 'bold',
        marginBottom: 4,
        color: '#1e293b'
    },
    resourceItem: {
        fontSize: 8,
        marginLeft: 10,
        color: '#475569',
        marginBottom: 2
    },

    // --- COMPACT VERSION STYLES ---
    assignmentCardShort: {
        paddingVertical: 12,
        paddingHorizontal: 8,
        borderBottomWidth: 1,
        borderBottomColor: '#f1f5f9',
        backgroundColor: '#ffffff'
    },
    assignmentHeaderShort: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        marginBottom: 6
    },
    assignmentTitleShort: {
        fontSize: 10,
        fontFamily: 'Helvetica',
        fontWeight: 'bold',
        color: '#0f172a'
    },
    assignmentMetaShort: {
        fontSize: 8,
        color: '#64748b'
    },
    compactSubRow: {
        flexDirection: 'row',
        gap: 12,
        marginTop: 4
    },
    compactInfoBlock: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4
    },
    assignmentLocationShort: {
        fontSize: 8,
        color: '#475569',
        flexShrink: 1
    },
    labelSmallBold: {
        fontSize: 7,
        fontFamily: 'Helvetica',
        fontWeight: 'bold',
        color: '#64748b',
        marginRight: 4
    },
    assignmentResourcesShort: {
        fontSize: 8,
        color: '#334155',
        fontFamily: 'Helvetica',
        fontWeight: 'bold',
        marginTop: 2
    },
    travelTimesShort: {
        fontSize: 7.5,
        color: '#64748b'
    },
    assignmentNotesShort: {
        fontSize: 8,
        color: '#64748b',
        marginTop: 4,
        paddingLeft: 6,
        borderLeftWidth: 1,
        borderLeftColor: '#e2e8f0'
    },
    kolonneContainerShort: {
        marginTop: 4,
        paddingLeft: 4,
        borderLeftWidth: 1,
        borderLeftColor: '#f1f5f9'
    },
    kolonneHeadingShort: {
        fontSize: 7.5,
        fontFamily: 'Helvetica',
        fontWeight: 'bold',
        color: '#64748b',
        textTransform: 'uppercase',
        marginBottom: 2
    },
    resourceGroupRowShort: {
        flexDirection: 'row',
        gap: 4,
        marginBottom: 1
    },
    resourceSubLabelShort: {
        fontSize: 7,
        fontFamily: 'Helvetica',
        fontWeight: 'bold',
        color: '#94a3b8',
        width: 45
    },

    // --- DETAILED (STRETCHED) VERSION STYLES ---
    assignmentCardLong: { 
        minHeight: 180, // Gestreckt
        marginBottom: 24, 
        padding: 24, 
        borderWidth: 1, 
        borderColor: '#e2e8f0', 
        borderRadius: 16,
        backgroundColor: '#ffffff'
    },
    assignmentHeader: { 
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: 20,
        borderBottomWidth: 1,
        borderBottomColor: '#f1f5f9',
        paddingBottom: 12
    },
    assignmentTitle: { 
        fontSize: 14, 
        fontFamily: 'Helvetica',
        fontWeight: 'bold', 
        color: '#1e293b' 
    },
    assignmentSubHeader: {
        flexDirection: 'row',
        gap: 30,
        marginBottom: 20
    },
    assignmentMetaBlock: {
        flex: 1
    },
    metaLabelSmall: {
        fontSize: 7.5,
        fontFamily: 'Helvetica',
        fontWeight: 'bold',
        color: '#94a3b8',
        textTransform: 'uppercase',
        marginBottom: 4,
        letterSpacing: 0.5
    },
    metaValueSmall: {
        fontSize: 10,
        color: '#334155',
        lineHeight: 1.4
    },
    addressLabel: {
        fontSize: 7.5,
        fontFamily: 'Helvetica',
        fontWeight: 'bold',
        color: '#64748b',
        marginTop: 4
    },
    travelTimesLong: {
        marginTop: 8,
        padding: 10,
        backgroundColor: '#f8fafc',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#f1f5f9'
    },
    resourceSection: {
        marginTop: 8,
        padding: 16,
        backgroundColor: '#f8fafc',
        borderRadius: 10
    },
    assignmentBadge: {
        fontSize: 8,
        fontFamily: 'Helvetica',
        fontWeight: 'bold',
        paddingVertical: 3,
        paddingHorizontal: 10,
        borderRadius: 12,
        textTransform: 'uppercase'
    },
    badgeAktiv: { backgroundColor: '#eef2ff', color: '#3730a3' },
    badgePausiert: { backgroundColor: '#fff7ed', color: '#9a3412' },
    badgeDone: { backgroundColor: '#f0fdf4', color: '#166534' },
 
    resourceRow: { 
        flexDirection: 'row', 
        flexWrap: 'wrap', 
        gap: 8,
        marginTop: 6,
        marginBottom: 8
    },
    kolonneSectionLong: {
        marginBottom: 12,
        paddingBottom: 8,
        borderBottomWidth: 1,
        borderBottomColor: '#f1f5f9'
    },
    kolonneTitleLong: {
        fontSize: 9,
        fontFamily: 'Helvetica',
        fontWeight: 'bold',
        color: '#475569',
        marginBottom: 4,
        textTransform: 'uppercase'
    },
    resourceSubLabelLong: {
        fontSize: 8,
        fontFamily: 'Helvetica',
        fontWeight: 'bold',
        color: '#64748b',
        marginBottom: 4,
        marginTop: 4
    },
    resourceChip: { 
        fontSize: 9, 
        color: '#334155', 
        paddingVertical: 4, 
        paddingHorizontal: 10, 
        backgroundColor: '#ffffff', 
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#cbd5e1',
        fontFamily: 'Helvetica',
        fontWeight: 'bold'
    },
    notesBox: { 
        marginTop: 20, 
        padding: 16, 
        backgroundColor: '#fdfdfd', 
        borderRadius: 10, 
        borderLeftWidth: 4,
        borderLeftColor: '#3b82f6',
        borderWidth: 1,
        borderColor: '#f1f5f9',
        fontSize: 9, 
        color: '#475569', 
        lineHeight: 1.5
    },

    // Signature area
    signatureSection: { 
        marginTop: 40, 
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        gap: 40 
    },
    signatureBlock: { 
        flex: 1, 
        borderTopWidth: 1, 
        borderTopColor: '#cbd5e1', 
        paddingTop: 8 
    },
    signatureLabel: { 
        fontSize: 8, 
        fontFamily: 'Helvetica',
        fontWeight: 'bold',
        color: '#64748b' 
    },
    signatureSub: {
        fontSize: 7,
        color: '#94a3b8',
        marginTop: 2
    },

    // Footer
    footer: { 
        position: 'absolute', 
        bottom: 30, 
        left: 40, 
        right: 40, 
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        fontSize: 7, 
        color: '#94a3b8',
        borderTopWidth: 0.5,
        borderTopColor: '#f1f5f9',
        paddingTop: 10
    },
});
